import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import settings from "./settings/reducers";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistStore, persistReducer } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};
export default (routerReducer) =>
  persistReducer(
    persistConfig,
    combineReducers({
      router: routerReducer,
      settings,
    })
  );

// export default (history) =>
//   combineReducers({
//     router: connectRouter(history),
//     settings,
//   })
